import { render, staticRenderFns } from "./PdfInlineDisplayComponent.vue?vue&type=template&id=1a98e018&scoped=true"
import script from "./PdfInlineDisplayComponent.vue?vue&type=script&lang=js"
export * from "./PdfInlineDisplayComponent.vue?vue&type=script&lang=js"
import "./PdfInlineDisplayComponent.vue?vue&type=style&index=0&id=1a98e018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a98e018",
  null
  
)

export default component.exports